import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-grid-item-title',
    templateUrl: './grid-item-title.component.html',
    styleUrls: ['./grid-item-title.component.scss'],
    standalone: false
})
export class GridItemTitleComponent {
  @Input() title: string | undefined;
  @Input() spaceBetweenTitleAndTrailing: boolean = false;
}
